/** Renders the active left-pane stacked overlay (06 §2.1) from uiStore. */
import { useUiStore } from '../stores/uiStore';
import { NewChat } from '../components/contacts/NewChat';
import { NewGroupDetails, NewGroupMembers } from '../components/contacts/NewGroup';
import { Settings } from '../components/settings/Settings';

export function LeftOverlayHost() {
  const overlay = useUiStore((s) => s.leftOverlay);
  switch (overlay.kind) {
    case 'new-chat':
      return <NewChat />;
    case 'new-group-members':
      return <NewGroupMembers selected={overlay.selected} />;
    case 'new-group-details':
      return <NewGroupDetails selected={overlay.selected} />;
    case 'settings':
      return <Settings page={overlay.page} />;
    case 'none':
    default:
      return null;
  }
}
